const LS_HAPTICS = 'stormsurge-haptics-v1';

function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches
  );
}

function vibrateSupported(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

/** Touch haptics via `navigator.vibrate`; persisted in localStorage. */
export class FpsHaptics {
  private static enabled = FpsHaptics.loadEnabled();

  private static loadEnabled(): boolean {
    if (typeof localStorage === 'undefined') return isTouchDevice();
    const raw = localStorage.getItem(LS_HAPTICS);
    if (raw !== null) return raw === 'true';
    return isTouchDevice();
  }

  static isEnabled(): boolean {
    return FpsHaptics.enabled;
  }

  static setEnabled(on: boolean): void {
    FpsHaptics.enabled = on;
    try {
      localStorage.setItem(LS_HAPTICS, String(on));
    } catch {
      /* ignore quota / private mode */
    }
  }

  private static pulse(pattern: number | number[]): void {
    if (!FpsHaptics.enabled || !vibrateSupported()) return;
    try {
      navigator.vibrate(pattern);
    } catch {
      /* ignore unsupported / blocked vibrate */
    }
  }

  /** Weapon fire tap. */
  static vibrateLight(): void {
    FpsHaptics.pulse(12);
  }

  /** Hit confirm. */
  static vibrateMedium(): void {
    FpsHaptics.pulse(28);
  }

  /** Elimination punch. */
  static vibrateHeavy(): void {
    FpsHaptics.pulse(55);
  }

  /** Player took damage — staggered burst. */
  static vibratePattern(): void {
    FpsHaptics.pulse([30, 40, 30, 40, 50]);
  }
}
